import { printHtmlNodesToText, printHtmlNodesToJsx, generateJsxKey } from '@utils/ast';
import { PM2IArkComponent } from './comp.root.js';
import { jsx } from 'react/jsx-runtime';

const printIArkComponent = (node, context) => {
  return /*#__PURE__*/jsx(PM2IArkComponent, {
    learningObjectId: node.pm2.learningObjectId,
    learningObjectTitle: node.pm2.learningObjectTitle,
    displayMode: node.options.displayMode,
    isScrambled: node.pm2.isScrambled,
    previewImage: node.meta.previewImage,
    indexOrLevel: node.meta.indexOrLevel,
    richtextDescription: printHtmlNodesToJsx(node.meta.richTextDescription),
    lightboxDescription: printHtmlNodesToText(node.meta.lightboxDescription ?? []),
    node: node
  }, generateJsxKey(context));
};
const iArkComponentJsxPrinters = {
  "component-framework.i-ark": printIArkComponent
};

export { iArkComponentJsxPrinters, printIArkComponent };
//# sourceMappingURL=printer.to-jsx.js.map
